import { Component, OnInit, ElementRef } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ContextService } from 'app/services/context.service';
import { RemoteAssessment } from 'app/model/remote-assessment';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    private toggleButton: any;
    private sidebarVisible: boolean;
    userName = "";
    pharmacyName = "";
    title="QSPP Remote Assessment";
    showNavInfo=true;
    remoteAssessment: RemoteAssessment;
    currentWizardStepIndex = 0;
    isPostStepThreeReadOnlyWorkflow = false;
    constructor(public location: Location, private element: ElementRef, private context: ContextService, private route: ActivatedRoute) {
        this.sidebarVisible = false;
    }

    ngOnInit() {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        this.context.params.subscribe(p => {
            this.userName = p[2];
            this.pharmacyName = p[3];
        });
        this.context.remoteAssessment.subscribe(ra=>{
            this.remoteAssessment = ra;
            const typeid = ra?.assessment?.assessmentType?.id;
            if (typeid == "806390002")
            {
                this.title = "QSPP Expansion of Services Assessment";
            }
            else if (typeid == "806390005")
            {
                this.title = "QSPP Mid-Cycle Review Assessment";
            }
             else if (typeid == "806390003")
            {
                this.title = "QSPP Transition Review Assessment";
            }
            else if (typeid == "806390004")
            {
                this.title = "QSPP Initial Reaccreditation Assessment";
            }
             else if (typeid == "806390006")
            {
                this.title = "QSPP Mandatory Reassessment";
            }
        })
        this.context.wizardStepIndex.subscribe(stepIndex => {
            this.currentWizardStepIndex = typeof stepIndex === 'number' ? stepIndex : 0;
        });
        this.context.postStepThreeReadOnlyWorkflow.subscribe(enabled => {
            this.isPostStepThreeReadOnlyWorkflow = enabled === true;
        });
        if(window.location.href.search('pharmacy-registration')!=-1 || window.location.href.search('registration-completed')!=-1){
            this.title="Pharmacy Registration";
            this.showNavInfo=false;
        }
    }
    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementsByTagName('html')[0];
        

        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        html.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
    };
    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };
    isHome() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        if (titlee === '/home') {
            return true;
        }
        else {
            return false;
        }
    }
    isDocumentation() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        if (titlee === '/documentation') {
            return true;
        }
        else {
            return false;
        }
    }

    get showEosCreatedFromReadOnlyBadge(): boolean {
        const isExistingReadOnlyScenario = this.remoteAssessment?.readOnly === true;
        const isStepOneOrTwo = this.currentWizardStepIndex <= 1;
        const isPostStepThreeReadOnlyScenario = this.isPostStepThreeReadOnlyWorkflow && isStepOneOrTwo;

        return isExistingReadOnlyScenario || isPostStepThreeReadOnlyScenario;
    }
}
